<div class="kanban-board container-fluid">
  <!-- Filters Section -->
  <div class="filters-section">
    <div class="filters-header">
      <h3>Workshop Kanban Board</h3>
    </div>

    <div class="filters-content">
      <div class="search-container">
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon" (click)="onSearchChange()"><i class="fa fa-search"></i></span>
          <input pInputText #searchtextbox type="text" [(ngModel)]="searchTerm"
            placeholder="{{ 'general.search' | translate}}" (ngModelChange)="onSearchChange()">
          <!-- (ngModelChange)="searchRequest === '' && getReservationsSummary()"> -->
        </div>
      </div>

      <!-- Technician Filter Chips -->
      <div class="technician-filter-chips">
        <div class="chips-container">
          <!-- All Technicians Chip -->
          <div class="filter-chip" [class.active]="isTechnicianChipActive(null)" (click)="onTechnicianChipClick(null)">
            <span class="chip-text">All Technicians</span>
            <span class="chip-count">{{ getTechnicianJobCount(null) }}</span>
          </div>

          <!-- Individual Technician Chips -->
          <div class="filter-chip" *ngFor="let technician of technicians"
            [class.active]="isTechnicianChipActive(technician.ID)" (click)="onTechnicianChipClick(technician.ID)">
            <span class="chip-text">{{ technician.UserSalutation }}</span>
            <span class="chip-count">{{ getTechnicianJobCount(technician.ID) }}</span>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="kanban-container">
    <!-- Header with column names -->
    <div class="kanban-header">
      <div class="technician-header">Technician</div>
      <div class="status-header" *ngFor="let column of kanbanColumns">
        <div>{{ column.StatusName }}</div>
        <small>{{ column.Information }}</small>
      </div>
    </div>

    <!-- Loading indicator -->
    <div *ngIf="loading" class="loading-container">
      <p-progressSpinner></p-progressSpinner>
    </div>

    <!-- Kanban Grid -->
    <div *ngIf="!loading" class="kanban-grid">
      <div class="kanban-row" *ngFor="let technician of filteredTechnicians">
        <!-- Technician name column -->
        <div class="technician-cell">
          <div class="technician-info">
            <h4>{{ technician.UserSalutation }}</h4>
          </div>
        </div>

        <!-- Status columns for this technician -->
        <div class="kanban-cell" *ngFor="let column of kanbanColumns" cdkDropList
          [id]="getCellDropListId(technician.ID, column.StatusID)"
          [cdkDropListData]="getJobCardsForCell(technician.ID, column.StatusID)"
          [cdkDropListConnectedTo]="getAllDropListIds()" (cdkDropListDropped)="onDrop($event)">

          <!-- Job cards in this cell -->
          <div class="job-card" [ngClass]="getJobCardStatusClass(jobCard.StatusID)"
            *ngFor="let jobCard of getJobCardsForCell(technician.ID, column.StatusID)" cdkDrag>

            <div class="job-card-content" (click)="onJobCardClick(jobCard)">
              <div class="job-card-header">
                <span class="job-card-number">{{ jobCard.JobCardNo }}</span>
              </div>

              <div class="job-card-details">
                <div class="bike-info">
                  <strong>{{ jobCard.BikeDescription }}</strong>
                </div>
                <div class="cyclist-info">
                  {{ jobCard.CyclistDescription }}
                </div>
              </div>
              <div class="job-card-header" *ngIf="jobCard.TypeDescription">
                <span class="job-card-type">{{ jobCard.TypeDescription }}</span>
              </div>
              <div class="job-card-footer">
                <small class="duration">{{ jobCard.Duration }}min</small>
                <small class="check-in-date">{{ jobCard.DateCheckedIn | date:'MMM dd yyyy' }}</small>
              </div>
            </div>

            <!-- Drag placeholder -->
            <div class="job-card-placeholder" *cdkDragPlaceholder></div>
          </div>

          <!-- Empty state for cells with no cards -->
          <div class="empty-cell" *ngIf="getJobCardsForCell(technician.ID, column.StatusID).length === 0">
            <span class="empty-text">Drop here</span>
          </div>
        </div>
      </div>
    </div>

    <!-- No results message -->
    <div *ngIf="!loading && filteredTechnicians.length === 0" class="no-results">
      <i class="fas fa-search fa-3x"></i>
      <h4>No technicians match your filters</h4>
      <p>Try adjusting your filters or clearing them to see more results.</p>
    </div>
  </div>
</div>